// Root route — Phase G1.
//
// Mounts App.jsx, which runs the auth/registration/onboarding/
// placement/mascot gate ladder. When all gates pass, App renders
// <Outlet />, which renders whichever child route matches the URL.
//
// Gates are NOT routes — they're conditional rendering above the
// outlet, because they depend on app state (auth status, child
// registry, progress) and not on URL. A logged-out user visiting
// /session sees LoginScreen, not the session UI.

import { createRootRoute } from "@tanstack/react-router";
import App from "../App.jsx";
import { RouterErrorFallback } from "../components/RouterErrorFallback";

export const Route = createRootRoute({
  component: App,
  // MA-107: a crash of the app shell itself keeps the full-page recovery card.
  errorComponent: RouterErrorFallback,
});
